/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { Logger, clientUtil } from "@html-core";

class PrintUtil {
   private isSupportChromeOrIWAPrinterOption = false;
   private isChromeOrIWASupportPrintingAPI = false;
   constructor() {
      this.isChromeOrIWASupportPrintingAPI = this.isSupportChromeOrIWAPrinterAPI();
   }

   private isSupportChromeOrIWAPrinterAPI = () => {
      if (clientUtil.isChromeClient()) {
         try {
            // Check if chrome and chrome.printing exist before trying to use them
            if (typeof chrome !== "undefined" && chrome && chrome.printing && chrome.printing.getPrinters) {
               chrome.printing.getPrinters((printers) => {
                  Logger.info("The client supports chrome.printing API", Logger.PRINTER_RD);
               });
               return true;
            } else {
               Logger.info("The client doesn't support chrome.printing API", Logger.PRINTER_RD);
               return false;
            }
         } catch (e) {
            Logger.info("The client doesn't support chrome.printing API", Logger.PRINTER_RD);
            return false;
         }
      } else if (clientUtil.isIwaClient()) {
         try {
            // Check for global printing API (new spec)
            if ("printing" in window) {
               // Actually try to access the property to trigger any getter errors
               const printingAPI = (window as any).printing;
               Logger.info("The client supports printing API", Logger.PRINTER_RD);
               return true;
            } else {
               Logger.info("The client doesn't support printing API", Logger.PRINTER_RD);
               return false;
            }
         } catch (e) {
            Logger.info("The client doesn't support printing API", Logger.PRINTER_RD);
            return false;
         }
      } else {
         Logger.info("Web client doesn't support chrome or IWA printing API", Logger.PRINTER_RD);
         return false;
      }
   };

   public setSupportChromeNewPrinterVersion = (flag: boolean) => {
      this.isSupportChromeOrIWAPrinterOption = flag;
   };

   public isSupportChromeOrIWAPrinter = () => {
      return this.isSupportChromeOrIWAPrinterOption && this.isChromeOrIWASupportPrintingAPI;
   };
}

export const printUtil = new PrintUtil();
